/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function() {
    let tabs = document.querySelectorAll(".tab-button");
    let contents = document.querySelectorAll(".tab-content");
    if (tabs.length > 0) {
        tabs[0].classList.add("active");
        contents[0].classList.add("active");
    }

    tabs.forEach((tab, index) => {
        tab.addEventListener("click", function() {
            tabs.forEach(t => t.classList.remove("active"));
            contents.forEach(c => c.classList.remove("active"));

            tab.classList.add("active");
            contents[index].classList.add("active");
        });
    });
    let butonQuote = document.querySelector('[href="#request-quote"]');
    let formQuote = document.getElementById('request-quote');

    butonQuote.addEventListener("click", function() {
        let parentContainer = formQuote.closest(".tab-content");
    
        if (parentContainer) {
            let id = parentContainer.getAttribute("id");
    
            if (id) {
                // Remove active class from all tabs and contents
                tabs.forEach(t => t.classList.remove("active"));
                contents.forEach(c => c.classList.remove("active"));
    
                // Select and activate the correct tab button
                let targetTabButton = document.querySelector(`.tab-button[data-tab="${id}"]`);
                if (targetTabButton) {
                    targetTabButton.classList.add("active");
                }
    
                // Activate the correct tab content
                let targetTabContent = document.getElementById(id);
                if (targetTabContent) {
                    targetTabContent.classList.add("active");
                }
            }
        }
    });

    document.querySelector('.mega-menu__inner .mega-menu__column:nth-child(1) a.mega-menu__title').setAttribute('href', '/pages/products#general_surgery');
    // document.querySelector('.mega-menu__inner .mega-menu__column:nth-child(2) a.mega-menu__title').setAttribute('href', '/pages/products#neuro_spine');
    
});